import { Factory } from 'miragejs'
import { RolloverStep } from 'teacher-ui-client/school-rollover/steps'
import { STATUS_ACTIVE } from 'teacher-ui-client/models/school-rollover'
import { formatISO } from 'date-fns'

export default Factory.extend({
  status: STATUS_ACTIVE,
  step: RolloverStep.Teachers,
  createdAt() {
    return formatISO(new Date())
  },
  updatedAt() {
    return formatISO(new Date())
  },
})
